import { fetchEcompage } from '@/apis/queryFunctions/ecompagesFunctions';
import { ecompagesKeys } from '@/apis/queryKeys';
import { QueryClient } from '@tanstack/react-query';

export default async function ensureQuerySeoPage(pageName, locale = "vi") {
    let dataSEO = null;
    const queryClient = new QueryClient();
    const dataPage = await queryClient.ensureQueryData(ecompagesKeys.detail(pageName), () => fetchEcompage(pageName, locale))

    if (dataPage.length) {
        dataSEO = {
            title: dataPage?.meta_title || dataPage?.title,
            description: dataPage?.meta_description || null,
            keywords: dataPage?.meta_keywords || null,
            picture1: dataPage?.meta_picture_1 || null,
            picture2: dataPage?.meta_picture_2 || null,
        }
    }

    return { queryClient, dataSEO }
}
